<script setup>
import { Logger } from '@/middlewares/sentry';
import { useSaveDateStore } from '@/stores/saveDate/saveDate.store';
import { SaveDateVersionList } from 'interface/data/saveDate/verions';
import { ref, shallowRef, onMounted, defineAsyncComponent } from 'vue';

const saveDateStore = useSaveDateStore();

const Version = shallowRef(null);
const componentLoaded = ref(false);

function pickVersion() {
  const isVersionExist = Object.values(SaveDateVersionList).includes(
    saveDateStore.getCommonData.version,
  );
  if (isVersionExist) {
    Version.value = defineAsyncComponent(
      () =>
        import(
          `../../layouts/clients/saveDate/${saveDateStore.getCommonData.version}.vue`
        ),
    );
    componentLoaded.value = true;
  } else {
    Logger.error(
      'Wrong save the date verion ' + saveDateStore.getCommonData.version,
    );
  }
}

onMounted(() => {
  pickVersion();
});
</script>

<template>
  <Version v-if="componentLoaded" />
</template>
